import {useConfig} from '@aboutyou/config';
import {useInitialLocation} from '@aboutyou/router';
import {useSessionGender} from '../../../shared-deprecated/sessionGender';
import {useWalletStateManager} from './useWalletStateManager';

export const useWallet = () => {
  const {device} = useConfig();
  const {gender} = useSessionGender();
  const initialLocation = useInitialLocation();
  const {isOpen, cancel, hide} = useWalletStateManager();

  const handleOnClose = () => {
    // On desktop, when the entry page is the deep link "/cw" or "/coins" and the gender is kids, the user gets
    // in an infinite loop when closing the wallet, since history back is used, sending the user
    // to the home page, and then the kids category page redirect kicks in
    if (
      device === 'desktop' &&
      ['/cw', '/coins'].includes(initialLocation.pathname) &&
      gender === 'kids'
    ) {
      hide();
    } else {
      cancel();
    }
  };

  return {
    isOpen,
    cancel,
    handleOnClose,
  };
};
